import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { useDashboard } from "../../contexts/DashboardContext";

import "../../styles/dashboard.css";

import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";

const DashboardLayout = () => {
  const location = useLocation();

  const {
    sidebarCollapsed,

    mobileSidebarOpen,

    pageTitle,

    openMobileSidebar,
    closeMobileSidebar,

    toggleSidebar,
  } = useDashboard();

  useEffect(() => {
    closeMobileSidebar();
  }, [location.pathname, closeMobileSidebar]);

  return (
    <>
      <div className="dashboard-shell">
        <DashboardSidebar
          isOpen={mobileSidebarOpen}
          isCollapsed={sidebarCollapsed}
          onClose={closeMobileSidebar}
          onToggleCollapse={toggleSidebar}
        />

        <div
          className={`dashboard-main ${
            sidebarCollapsed ? "is-collapsed" : ""
          }`}
        >
          <DashboardNavbar
            pageTitle={pageTitle}
            sidebarCollapsed={sidebarCollapsed}
            onMenuClick={openMobileSidebar}
            onToggleSidebarCollapse={toggleSidebar}
          />

          <main className="dashboard-content">
            <Outlet />
          </main>

          <footer className="dashboard-footer">
            <div className="dashboard-footer__left">
              © 2026 Urbania. All rights reserved.
            </div>

            <div className="dashboard-footer__right">
              Version 1.0.0
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
